import React from "react";
import "./SubstituteSelector.scss";

/**
 * Reusable loading spinner component
 * @param {string} className - Additional CSS classes
 * @param {boolean} inline - If true, renders inline spinner for buttons
 */
const LoadingSpinner = ({ className = "", inline = false }) => {
  if (inline) {
    return <div className="loader"></div>;
  }

  return (
    <div className={`ss-loader-container ${className}`}>
      <div className="loader"></div>
    </div>
  );
};

export default LoadingSpinner;

